import React, { useEffect, useReducer, useState } from 'react';
import { connect } from 'react-redux';
import { get, isEmpty, toLower } from 'lodash';
import Select from 'react-select';

import {
    getDomainAvailability,
    saveGetDomainPage, getDomainStatus
} from '../../store/signup/signupAction';
import { industry } from '../../utilities/industry';

import './GetDomain.scss';

const actions = {
    BUSINESS_NAME: 'BUSINESS_NAME',
    BUSINESS_TYPE: 'BUSINESS_TYPE',
    DOMAIN_DETAILS: 'DOMAIN_DETAILS',
    DOMAIN_NAME: 'DOMAIN_NAME',
};
/**
 * Reducer function
 * @param {*} state
 * @param {*} action
 */
function reducer(state, action) {
    switch (action.type) {
        case actions.BUSINESS_NAME:
            return { ...state, businessName: action.payload };
        case actions.BUSINESS_TYPE:
            return { ...state, businessTypes: action.payload };
        case actions.DOMAIN_DETAILS:
            return { ...state, domainDetails: action.payload };
        case actions.DOMAIN_NAME:
            return { ...state, domainName: action.payload };
        default:
            throw new Error();
    }
}

/**
 * Domain search component
 * @param {*} param0
 */
const DomainSearch = ({
    getDomainAvailability,
    basicData,
    setIsLoading,
    suggestions,
    domainAvailable,
    domainPrice,
    saveGetDomainPage,
    initData = {},
    domainNameError,
    businessNameError,
    industryError,
    setIndustryError,
    setBusinessNameError,
    setDomainNameError, getDomainStatus
}) => {
    const [requestedDomain, setRequestedDomain] = useState(
        initData ? get(initData, 'domainName') : ''
    );
    const [domainErrorMgs, setDomainErrorMgs] = useState('Required');
    const [searchedDomain, setSearchedDomain] = useState('');
    const [searched, setSearched] = useState(false);
    const [selectedSuggestion, setSelectedSuggestion] = useState(null);
    const [businessData, dispatch] = useReducer(reducer, initData);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [domainError, setdomainError] = useState(domainNameError);
    const [searchText, setSearchText] = useState('Search');

    useEffect(() => {
        setdomainError(domainNameError);
        let errMsg = "Required";
        if (!validateRegex(requestedDomain)) {
            errMsg = 'Domain name should contain a top level domain.'
        } else if (domainNameError && !isEmpty(requestedDomain)) {
            errMsg = "Please click Search button to select your domain from the available list"
        }
        domainNameError && setDomainErrorMgs(errMsg);
    }, [domainNameError, setdomainError, requestedDomain]);

    /**
     * Validate domain with regular expression
     * @param {*} domain 
     */
    const validateRegex = domain => {
        return domain && domain.includes('.') &&
            /^(?!:\/\/)[a-zA-Z0-9][a-zA-Z0-9-_]+(\b\.com\b|\b\.net\b|\b\.org\b|\b\.co\b|\b\.biz\b|\b\.info\b|\b\.tech\b|\b\.online\b|\b\.website\b)?$/.test(
                domain
            )
    }
    /**
     * Validate domain name and search for it
     * @param {*} requestedDomain
     * @param {*} searchingText
     */
    const validateAndFindDomain = (
        requestedDomain,
        searchingText = 'Searching...'
    ) => {
        if (!isEmpty(requestedDomain) && validateRegex(requestedDomain)) {
            setButtonLoader(true);
            setSearched(false);
            setSearchText(searchingText);
            setSearchedDomain(requestedDomain);
            getDomainStatus(requestedDomain, basicData.form_id).then(resp => {
                if (resp.status) {
                    setDomainNameError(true);
                    setButtonLoader(false);
                    setSearchText('Search');
                    setdomainError(true);
                    dispatch({ type: actions.DOMAIN_DETAILS, payload: {} });
                    setDomainErrorMgs('This domain is already registed with InfinCE. Please try another domain.');
                } else {
                    getDomainAvailability(requestedDomain, basicData.form_id).then(
                        (res) => {
                            setSearched(true);
                            setButtonLoader(false);
                            setSearchText('Search');
                            if (res.status === 'success') {
                                dispatch({
                                    type: actions.DOMAIN_DETAILS,
                                    payload: {
                                        ...get(res, 'data', {}),
                                        domain: requestedDomain,
                                        suggestions: null,
                                    },
                                });
                            }
                            setDomainNameError(false);
                        }
                    );
                }
            })
        } else {
            setDomainNameError(true);
            setDomainErrorMgs('Domain name should contain a top level domain.');
        }
    };
    useEffect(() => {
        saveGetDomainPage(businessData);
    }, [businessData, saveGetDomainPage]);
    /**
     * Select domain form options
     * @param {*} suggestion
     */
    const selectDomain = (suggestion) => {
        setSelectedSuggestion(suggestion.domain);
        setRequestedDomain(suggestion.domain);
        dispatch({
            type: actions.DOMAIN_NAME,
            payload: suggestion.domain,
        });
        validateAndFindDomain(suggestion.domain, 'Checking...');
        dispatch({ type: actions.DOMAIN_DETAILS, payload: suggestion });
    };
    return (
        <>
            <div className="form-group">
                <input
                    className={`form-control ${businessNameError && 'inf-error'
                        }`}
                    type="text"
                    placeholder="Business Name"
                    onChange={(e) => {
                        setBusinessNameError(false);
                        dispatch({
                            type: actions.BUSINESS_NAME,
                            payload: e.target.value,
                        });
                    }}
                    value={businessData.businessName}
                />
                {businessNameError && (
                    <span className="input-error">Required</span>
                )}
            </div>
            <div className="form-group">
                <Select
                    className={`${industryError && 'inf-error'}`}
                    onChange={(data) => {
                        setIndustryError(false);
                        dispatch({
                            type: actions.BUSINESS_TYPE,
                            payload: data,
                        });
                    }}
                    isMulti={true}
                    options={industry}
                    placeholder="Select Industry"
                    value={businessData.businessTypes}
                />
                {industryError && <span className="input-error">Required</span>}
            </div>
            <div className="form-group input-btn-group">
                <input
                    className={`form-control ${domainError && 'inf-error'}`}
                    type="text"
                    placeholder="Enter Domain of Your Choice"
                    onChange={(e) => {
                        setRequestedDomain(toLower(e.target.value));
                        dispatch({
                            type: actions.DOMAIN_NAME,
                            payload: toLower(e.target.value),
                        });
                        setDomainNameError(false);
                        setdomainError(false);
                    }}
                    onKeyUp={() => setDomainNameError(false)}
                    value={requestedDomain}
                />
                <button
                    onClick={() => validateAndFindDomain(requestedDomain)}
                    className="btn-tertiary"
                    disabled={buttonLoader}
                >
                    {searchText}
                </button>
                {domainError && (
                    <span className="input-error">{domainErrorMgs}</span>
                )}
                <p className="note">
                    <span className="badge">.com</span>
                    <span className="badge">.net</span>
                    <span className="badge">.org</span>
                    <span className="badge">.co</span>
                    <span className="badge">.biz</span>
                    <span className="badge">.info</span>
                    <span className="badge">.tech</span>
                    <span className="badge">.online</span>
                    <span className="badge">.website</span> are supported
                </p>
            </div>
            {searched && (
                <>
                    {domainAvailable ? (
                        <>
                            <p className="searched-domain-msg">
                                Domain Charges for{' '}
                                <strong>{searchedDomain}</strong> ${domainPrice}
                            </p>
                            <p>
                                The above mentioned charges are for a duration
                                of 1 year , thereafter it will be renewed
                                automatically.
                            </p>
                        </>
                    ) : (
                        <>
                            {suggestions.filter(el => el.available && el).length > 0 ? (
                                <>
                                    <p className="searched-domain-msg">
                                        Sorry, <strong>{searchedDomain}</strong>{' '}
                                        is already taken, but below domains are
                                        available!
                                    </p>
                                    <div className="inf-domain-table">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>More options</th>
                                                    <th>Domain Price</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {suggestions.map(
                                                    (suggestion) => suggestion.available && (
                                                        <tr
                                                            key={
                                                                suggestion.domain
                                                            }
                                                        >
                                                            <td width="50%">
                                                                {
                                                                    suggestion.domain
                                                                }
                                                            </td>
                                                            <td>
                                                                <strong>
                                                                    $
                                                                    {
                                                                        parseFloat(suggestion.price).toFixed(2)
                                                                    }
                                                                </strong>
                                                            </td>
                                                            <td className="align-right">
                                                                <button
                                                                    className={
                                                                        suggestion.domain ===
                                                                            selectedSuggestion
                                                                            ? 'btn-selected'
                                                                            : 'btn-select'
                                                                    }
                                                                    onClick={() =>
                                                                        selectDomain(
                                                                            suggestion
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        suggestion.domain ===
                                                                        selectedSuggestion
                                                                    }
                                                                >
                                                                    {suggestion.domain ===
                                                                        selectedSuggestion
                                                                        ? 'Selected'
                                                                        : 'Select'}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {' '}
                                    <p className="searched-domain-msg">
                                        Sorry, <strong>{searchedDomain}</strong>
                                        is already taken, please try another
                                        domain name!
                                    </p>
                                </>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

const mapDispatchToProps = {
    getDomainAvailability,
    saveGetDomainPage, getDomainStatus
};
const mapStateToProps = (store, props) => ({
    basicData: get(store, 'signupReducer.basicData', null),
    suggestions: get(store, 'signupReducer.domainSuggestions.suggestions', []),
    domainAvailable: get(
        store,
        'signupReducer.domainSuggestions.available',
        false
    ),
    domainPrice: get(store, 'signupReducer.domainSuggestions.price', 0),
});

export default connect(mapStateToProps, mapDispatchToProps)(DomainSearch);
